/**
 * Return if an array or an object is empty
 * @param {*} item
 */
// eslint-disable-next-line import/prefer-default-export
export const isEmpty = (item) => {
  if (!item) {
    return true;
  }

  if (Array.isArray(item) && item.length === 0) {
    return true;
  }

  if (typeof item === 'object' && Object.keys(item).length === 0) {
    return true;
  }

  return false;
};

export const isObject = (obj) => obj != null && obj.constructor.name === 'Object';
